import { Component, signal, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { ToastContainer } from "./shared/components/toast-container/toast-container";
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastContainer],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('nihs-museum-admin-fe');
  private swUpdate = inject(SwUpdate);
  ngOnInit() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          if (confirm('A new version of the app is available. Load it now?')) {
            window.location.reload();
          }
        }
      });
    }
  }
  constructor() {
    if (typeof window !== 'undefined') {
      const globalWindow = window as any;
      if ('statusbar' in globalWindow) {
        try {
          const sb = globalWindow.statusbar;
          if (sb && typeof sb.hide === 'function') {
            sb.hide();
          }
        } catch (e) {
          // ignore runtime errors from unfamiliar statusbar implementations
        }
      }
    }
  }

  async requestFullscreen() {
    if (document.documentElement.requestFullscreen) {
      await document.documentElement.requestFullscreen();
    }
  }
}
